import { LoadingSpinner } from '@youversion/design-system-components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * The full-page loading spinner component.
 *
 * @example
 * ```typescript
 * import { useSession } from '@youversion/next-auth-react';
 * import { FullPageLoader } from '@/components/loaders';
 *
 * const MyPage: NextPage = () => {
 *   const { isLoading } = useSession();
 *
 *   if (isLoading) {
 *     return <FullPageLoader />;
 *   }
 *
 *   // ...return page content
 * }
 * ```
 */
export function FullPageLoader() {
  const { t } = useTranslation();
  return (
    <div className='flex items-center justify-center w-screen h-screen'>
      <LoadingSpinner aria-label={t('loading')} color='text-yv-red' />
    </div>
  );
}
